import React from "react";

export const ArbitrumIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask id="mask0_1105_4046" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="20">
      <path d="M18 0H0V20H18V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_1105_4046)">
      <path
        d="M10.5066 11.5199L9.52179 14.1748C9.49274 14.2484 9.49274 14.3302 9.52179 14.4039L11.2129 18.9734L13.17 17.8606L10.8224 11.5199C10.7683 11.3726 10.5606 11.3726 10.5066 11.5199Z"
        fill="#1B4ADD"
      />
      <path
        d="M12.4786 7.05258C12.4246 6.90533 12.2169 6.90533 12.1629 7.05258L11.1781 9.70751C11.149 9.7812 11.149 9.86301 11.1781 9.93664L13.9495 17.4188L15.9066 16.306L12.4786 7.05258Z"
        fill="#1B4ADD"
      />
      <path
        d="M9 1.23952C9.04984 1.23952 9.09559 1.25179 9.14127 1.27634L16.6039 5.51851C16.6912 5.5676 16.7452 5.6576 16.7452 5.75578V14.2401C16.7452 14.3383 16.6912 14.4283 16.6039 14.4774L9.14127 18.7237C9.09974 18.7482 9.04984 18.7605 9 18.7605C8.95016 18.7605 8.90441 18.7482 8.85873 18.7237L1.40028 14.4815C1.31302 14.4324 1.259 14.3424 1.259 14.2443V5.75578C1.259 5.6576 1.31302 5.5676 1.40028 5.51851L8.86289 1.27634C8.90441 1.25179 8.95432 1.23952 9 1.23952ZM9 0C8.7341 0 8.46813 0.0695437 8.23128 0.204541L0.768699 4.44672C0.295014 4.71671 0 5.21579 0 5.75578V14.2401C0 14.7801 0.295014 15.2833 0.768699 15.5533L8.23128 19.7954C8.46813 19.9304 8.7341 20 9 20C9.2659 20 9.53187 19.9304 9.76872 19.7954L17.2313 15.5533C17.7091 15.2833 18 14.7842 18 14.2401V5.75578C18 5.21579 17.705 4.71262 17.2313 4.44263L9.77288 0.204541C9.53187 0.0695437 9.2659 0 9 0Z"
        fill="#1B4ADD"
      />
      <path
        d="M4.07031 17.4269L4.75591 15.5779L6.13541 16.7069L4.84732 17.8687L4.07031 17.4269Z"
        fill="#1B4ADD"
      />
      <path
        d="M8.37115 5.15039H6.48059C6.33932 5.15039 6.21046 5.2363 6.16477 5.3672L2.10938 16.3142L4.06644 17.4269L8.53321 5.3713C8.57057 5.26493 8.49162 5.15039 8.37115 5.15039Z"
        fill="#1B4ADD"
      />
      <path
        d="M11.6831 5.15039H9.79251C9.65125 5.15039 9.52239 5.2363 9.47671 5.3672L4.84375 17.8687L6.80079 18.9815L11.841 5.37538C11.8825 5.26493 11.7995 5.15039 11.6831 5.15039Z"
        fill="#1B4ADD"
      />
    </g>
  </svg>
);
